import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import BulkHiring from "@/components/sections/BulkHiring";
import AIServices from "@/components/sections/AIServices";
import Clients from "@/components/sections/Clients";
import Stats from "@/components/sections/Stats";
import Testimonials from "@/components/sections/Testimonials";
import Candidates from "@/components/sections/Candidates";
import Industries from "@/components/sections/Industries";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import Contact from "@/components/sections/Contact";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function HomePage() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 80);
    }
  }, [location.hash]);

  return (
    <>
      <Navbar />
      <main data-testid="home-main">
        <Hero />
        <About />
        <Services />
        <BulkHiring />
        <AIServices />
        <Clients />
        <Stats />
        <Industries />
        <WhyChooseUs />
        <Testimonials />
        <Candidates />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
